'use strict';

import { addBrowserClasses } from './modules/_utils';
import './modules/_nav';
import './modules/_modal';
import './modules/_resizeTimer';
import './modules/_scrollTop';
import './modules/_accordion';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', function() {


  document.getElementsByClassName('no-js')[0].classList.remove('no-js');

  // Common functions
  addBrowserClasses();


  // GSAP
  // -------------------------------------------------------------
  gsap.to(".box", {
    scrollTrigger: ".box",
    x: 500,
  });






});
